import { render } from "./FooterBase.vue?vue&type=template&id=3f6e3e6b&scoped=true"
const script = {}

import "./FooterBase.vue?vue&type=style&index=0&id=3f6e3e6b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f6e3e6b"]])

export default __exports__